import { Component, OnInit, Input } from '@angular/core';
import { TcRegistraionService } from 'projects/registration/src/app/tc-registration/tc-registraion.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Location } from '@angular/common';
import { LoginService } from 'projects/services/src/app/API/login/login.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-view-tc-regiration-caaf-details',
  templateUrl: './view-tc-regiration-caaf-details.component.html',
  styleUrls: ['./view-tc-regiration-caaf-details.component.css']
})
export class ViewTcRegirationCaafDetailsComponent implements OnInit {

 // currentStep: any;
 formValidity: any;
 currentRoute: any;
 currentStep = 1;
 currentUserDetails: any;
 dataValidity = {
   'general': false,
   'facility': false,
   'jobRole': false,
   'centreArea': false,
   'centreStaff': false
 }
 @Input() formValueObject: any;
 @Input() formValid: any;
 currentUserWorkFlow = {
	tc: {_id: ''},
	tcworkflow: {
		tcId: '',
		createdOn: null,
		reqID: ''
	}
};
reviewData: any;
 constructor(private router: Router,
 private currentUserService: CurrentUserService,
 private location: Location,
 private loginService: LoginService,
   private tcRegistrationService: TcRegistraionService,
   ) {
	 switch (this.router.url) {
	 	case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/basic-info':
		this.currentStep = 1;
		break;
		case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/residential-facilities':
		this.currentStep = 2;
		break;
		case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/jobroleslist':
		this.currentStep = 3;
		break;
		case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/centre-area-details':
		this.currentStep = 4;
		break;
		case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/centre-staff-details':
		this.currentStep = 5;
		break;
		// case '/inspectionagency/view-tc-regi-caaf-details/mobile-upload':
		// this.currentStep = 6;

		// break;
		// case '/inspectionagency/view-tc-regi-caaf-details/declaration-payment':
		// this.currentStep = 7;

		// break;
		default:
		case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details':
		this.currentStep = 1;
		break;
	}

  }

	ngOnInit() {
	this.tcRegistrationService.getRoute()
	.subscribe(res => {
		this.currentRoute = res;
		this.tcRegistrationService.getformValidity().subscribe(data => {
			this.formValidity = data;
		});
	});
	 this.getCurrentUserDetails();
		this.router.events.subscribe(route => {
		if (route instanceof NavigationEnd) {

		switch (this.router.url) {
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/basic-info':
			this.currentStep = 1;
			break;
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/residential-facilities':
			this.currentStep = 2;
			break;
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/jobroleslist':
			this.currentStep = 3;

			break;
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/centre-area-details':
			this.currentStep = 4;

			break;
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/centre-staff-details':
			this.currentStep = 5;

			break;
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/mobile-upload':
			this.currentStep = 6;

			break;
			case '/' + String(this.router.url).split('/')[1] + '/view-tc-regi-caaf-details/declaration-payment':
			this.currentStep = 7;

			break;
			default:
			break;
		}
		}
		});
 }

 getCurrentUserDetails() {
	this.currentUserService.getCurrentUser()
	.subscribe(res => {
	this.currentUserDetails = res;
	});
 }

 test(event) {
   // console.log('parent', event);
 }
	showPrevious() {
		if (this.currentRoute === '/view-tc-regi-caaf-details/basic-info') {
			this.currentStep = 1;
			return true;
		} else if (this.currentRoute === '/view-tc-regi-caaf-details/residential-facilities') {
			this.currentStep = 2;
			return true;
		} else if (this.currentRoute === '/view-tc-regi-caaf-details/centre-area-details') {
			this.currentStep = 4;
			return true;
		} else if (this.currentRoute === '/view-tc-regi-caaf-details/job-role-list') {
			this.currentStep = 3;
			return true;
		} else if (this.currentRoute === '/view-tc-regi-caaf-details/centre-staff-details') {
			this.currentStep = 5;
			return true;
		} else {
			this.currentStep = 1;
			return false;
		}
 	}
 next() {
 }

	prev() {
		this.location.back();
		this.router.events.subscribe(route => {
		switch (this.router.url) {
			case '/view-tc-regi-caaf-details/basic-info':
			this.currentStep = 1;
			break;
			case '/view-tc-regi-caaf-details/residential-facilities':
			this.currentStep = 2;
			break;
			case '/view-tc-regi-caaf-details/jobroleslist':
			this.currentStep = 3;

			break;
			case '/view-tc-regi-caaf-details/centre-area-details':
			this.currentStep = 4;

			break;
			case '/view-tc-regi-caaf-details/centre-staff-details':
			this.currentStep = 5;

			break;
			default:
			break;
		}
   });
 }

	logout() {
   const cred = {
	userName: this.currentUserDetails.userName
   };
   this.loginService.logout(cred).subscribe(res => { });
   this.router.navigate(['/']);
 }

 navigation(value) {
	switch (value) {
		case 'general':
			this.router.navigate(['/' + String(this.router.url).split('/')[1] + `/view-tc-regi-caaf-details/basic-info`]);
			this.currentStep = 1;
			break;
		case 'facility':
			if (this.formValidity.general) {
				this.router.navigate(['/' + String(this.router.url).split('/')[1] + `/view-tc-regi-caaf-details/residential-facilities`]);
				this.currentStep = 2;
			}
			break;
		case 'jobRole':
			if (this.formValidity.facility) {

				this.router.navigate(['/' + String(this.router.url).split('/')[1] + `/view-tc-regi-caaf-details/jobroleslist`]);
				this.currentStep = 3;
			}
			break;
		case 'centreArea':
			if (this.formValidity.jobRoles) {

				this.router.navigate(['/' + String(this.router.url).split('/')[1] + `/view-tc-regi-caaf-details/centre-area-details`]);
				this.currentStep = 4;
			}
			break;
		case 'centreStaff':
			if (this.formValidity.centreArea) {

				this.router.navigate(['/' + String(this.router.url).split('/')[1] + `/view-tc-regi-caaf-details/centre-staff-details`]);
				this.currentStep = 5;
			}
			break;
			default:
			break;
	}

}
}
